import classnames from 'classnames';
import { componentStyles } from "./media-item-component.scss";

const MediaItem = ({ backgroundColor, title, description, icon, direction }) => {
  return (
    <div className={classnames("media-item--wrapper", direction)}>
      <div className="media-item--icon-wrapper" style={{ backgroundColor }}>
        <img className="media-item--icon" src={icon} alt={title} />
      </div>
      <div className="media-item--text">
        <div className="media-item--title">{title}</div>
        <div className="media-item--subtitle">{description}</div>
      </div>

      <style jsx>{componentStyles}</style>
    </div>
  );
}

MediaItem.defaultProps = {
};

export default MediaItem;
